export default __webpack_public_path__ + "static/media/Logo_Oktio_last.70e4a1fa.png";